import { fromJS } from 'immutable';
import * as ACTIONS from  '../containers/constants';

const initialState = fromJS({});

export function userReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.CRYODEX_UPDATE_USER:
    return {
      ...state,
      data: action.payload,
    };
    case ACTIONS.CRYODEX_EDIT_UPDATE:
    default:
      return state;
  }
}
 
export default userReducer;
